export const getInboxUpdates = (store => store.inboxUpdates || {});
export const getInboxUpdateDetail = (store => store.inboxUpdateDetail || {});
